import { getLangKey } from 'models/Language';
import inviteTeamOnboardingImage from './assets/invite-team-onboarding.png';
import * as translations from './strings';

const strings = translations[getLangKey()];

export enum ChecklistEnum {
  SETUP_PROJECT = 0,
  INSTALL_BH,
  WEBSITE,
  INVITE_TEAM
}

enum StepStatusEnum {
  Pending = 0,
  InProgress,
  Done
}

type OnboardingStepsType = {
  step: ChecklistEnum;
  title: string;
  activeTitle: string;
  visibleStepTitle: string;
  status: StepStatusEnum;
  helpVideoKey?: string;
  guideMessage?: string;
  videoLength?: string;
  helpArticleId?: string;
  guideMessagePara?: string;
  rightPanelImage?: string;
};

export const OnboardingSteps: OnboardingStepsType[] = [
  {
    step: ChecklistEnum.SETUP_PROJECT,
    title: strings.setupProjectTitle,
    visibleStepTitle: strings.setupProjectVisibleStepTitle,
    activeTitle: '',
    status: StepStatusEnum.Pending,
    helpVideoKey: strings.createVideoKey,
    guideMessage: strings.createGuideMessage,
    videoLength: strings.createVideoLength,
    helpArticleId: strings.setupProjectHelpArticleId
  },
  {
    step: ChecklistEnum.INSTALL_BH,
    title: strings.installBugHerdTitle,
    visibleStepTitle: strings.installBugHerdVisibleStepTitle,
    activeTitle: strings.installBugHerdTitleDone,
    status: StepStatusEnum.Pending,
    helpVideoKey: strings.installVideoKey,
    guideMessage: strings.installGuideMessage,
    guideMessagePara: strings.installGuideMessagePara,
    videoLength: strings.installVideoLength,
    helpArticleId: strings.installHelpArticleId
  },
  {
    step: ChecklistEnum.WEBSITE,
    title: strings.tryOnWebsiteTitle,
    visibleStepTitle: strings.tryOnWebsiteVisibleStepTitle,
    activeTitle: strings.tryOnWebsiteTitleDone,
    status: StepStatusEnum.Pending,
    helpVideoKey: strings.feedbackVideoKey,
    guideMessage: strings.feedbackGuideMessage,
    guideMessagePara: strings.feedbackGuideMessagePara,
    videoLength: strings.feedbackVideoLength,
    helpArticleId: strings.tryBugHerdHelpArticleId
  },
  {
    step: ChecklistEnum.INVITE_TEAM,
    title: strings.inviteTeamTitle,
    visibleStepTitle: strings.inviteTeamVisibleStepTitle,
    activeTitle: strings.inviteTeamTitleDone,
    status: StepStatusEnum.Pending,
    helpVideoKey: strings.inviteTeamVideoKey,
    guideMessage: strings.inviteTeamGuideMessage,
    guideMessagePara: strings.inviteTeamGuideMessagePara,
    videoLength: strings.inviteTeamVideoLength,
    helpArticleId: strings.inviteTeamHelpArticleId,
    rightPanelImage: inviteTeamOnboardingImage
  }
];
